import { render, staticRenderFns } from "./AdminChecklist.vue?vue&type=template&id=624d8508&scoped=true&"
import script from "./AdminChecklist.vue?vue&type=script&lang=js&"
export * from "./AdminChecklist.vue?vue&type=script&lang=js&"
import style0 from "./AdminChecklist.vue?vue&type=style&index=0&id=624d8508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d8508",
  null
  
)

export default component.exports